import UserStore from '@/store/User';

// 容量是否够用
export function isStorageAvailable(occupied: number) {
  const {
    key,
    spaceStorage: { used, total },
  } = UserStore.getState().currentVip;

  if (key === 'enterpriseVip') {
    return true;
  }

  return used + occupied <= total;
}

export async function getUrlFileSize(url: string): Promise<number | null> {
  try {
    const response = await fetch(url, { method: 'HEAD' });
    if (!response.ok) {
      return null;
    }

    const size = response.headers.get('content-length');
    return size ? parseInt(size) : null;
  } catch (error) {
    console.error('Error fetching file size:', error);
    return null;
  }
}
